var app = angular.module('leonardo');

var SpinDirective = function() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.spin();
    }
  };
};

app.directive('spin', [SpinDirective]);
